export const TeamProfiles = [
  {
    name: "Rebecca Soo",
    position: "CEO",
    description:
      "Hi! I’m Rebecca! I am majoring in Sociology and Media Studies with a minor in Public Policy. In my free time I like finding new snacks at Trader Joe’s and taking pictures of sunsets. I love Spero because it gives us the opportunity to be a light on campus and meet new people :’)",
    image: require("../../images/updated-staff/Rebecca-min.jpg"),
  },
  {
    name: "Dorcas Cheung",
    position: "Marketing Lead",
    description:
      "hello!! I am Dorcas, a Business and Public Policy student at Berkeley. I am passionate about marketing strategies, storytelling, and social impact. You will find me going on a run, planning the next picnic, and listening to podcasts in my free time. I hope that through Spero, we will bring attention to His glory.",
    image: require("../../images/updated-staff/dorcas-min.jpg"),
  },
  {
    name: "Andrew Cheng",
    position: "Operations Lead",
    description:
      "What is up!! I'm Andrew, a fourth year at UC Berkeley studying Data Science and music. I love basketball, running, acappella, magic, camping, smash ultimate, and many other small things in life! I'm serving in Spero because I hope to use fashion as a platform to spread the gospel!",
    image: require("../../images/updated-staff/Andrew-min.jpg"),
  },
  {
    name: "James Shin",
    position: "Development Lead",
    description:
      "Hello! I'm James Shin, a senior at UC Berkeley studying Computer Science. I love reading, playing the guitar, wearing big hoodies, binging shows (watch The West Wing and Bojack Horseman), and working with all the talented, creative, and God-fearing people at Spero!",
    image: require("../../images/updated-staff/James-min.jpg"),
  },
  {
    name: "Jasmine Chen",
    position: "Design Lead",
    description:
      "hi friends (о´∀`о) I'm Jasmine, a third year at Cal studying Architecture! In my free time, I like to go thrifting, play with my dogs, watch korean dramas, and make stickers!! I joined Spero because I wanted to design for a higher purpose, and hopefully learn new ways to think about my faith!",
    image: require("../../images/updated-staff/jasmine-min.jpg"),
  },
  {
    name: "Justin Park",
    position: "Operations",
    description:
      "Hi everyone! I’m Justin (I go by JP), and I am a senior studying Data Science. When I have free time, I love going on walks, listening to music, and drinking coffee! I love Spero because of it gives me the opportunity to have conversations with people on campus about our mission and our Lord.",
    image: require("../../images/updated-staff/justin-min.jpeg"),
  },
  {
    name: "Matthew Flores",
    position: "Design",
    description:
      "Hi! I'm Matt and I'm a 4th year at UC Berkeley studying Cognitive Science and Design. I love to dance, shop for thrifted/vintage clothes, binge mockumentary comedies, and cafe hop to drink lattes! I love Spero because I'm able to combine my passions in design, fashion and faith to encourage others!",
    image: require("../../images/updated-staff/matt-min.jpg"),
  },
  {
    name: "Jenny Woo",
    position: "Marketing",
    description:
      "Heyhey!! I'm Jenny, a third year at UC Berkeley hoping to major in Public Health! I love photography (like photoshoots with friendzz), coffee, baking, calligraphy, and theology books (heh)! I joined Spero because I wanted to share the gospel through an art form 🙂",
    image: require("../../images/updated-staff/jenny-min.jpeg"),
  },
  {
    name: "Esther You",
    position: "Marketing",
    description:
      "Hi! I'm Esther, a third-year studying Econ and Public Policy. In my free time, I like to volunteer in my local community and watch TikToks. I joined Spero because of the amazing people and mission!",
    image: require("../../images/updated-staff/esther-min.jpg"),
  },
  {
    name: "William Louis",
    position: "Web Developer",
    description:
      "Hi everyone, I'm Will, a junior studying computer science and data science at UC Berkeley. A few of my hobbies include playing basketball, working out at the gym, and hanging out with friends. Spero has been an amazing experience for me thus far due to its outreach and mission.",
    image: require("../../images/updated-staff/will-min.jpg"),
  },
  {
    name: "Kristina Hiraishi",
    position: "Operations",
    description:
      "Hi! My name is Kristina, and I'm a Junior studying Data Science. My recent hobbies include playing basketball, listening to podcasts, cooking, and watching Korean dramas. I joined Spero for the community and to have more gospel-centered conversations!",
    image: require("../../images/updated-staff/kristina-min.jpg"),
  },
  {
    name: "Chanel Jung",
    position: "Operations",
    description:
      "Hey, I'm Chanel! I'm majoring in Business Administration with a concentration in Global Management. I love being a part of the Spero family because I get to spread the love of God through creative outlets and to be able to connect with new people through the gospel. :)",
    image: require("../../images/updated-staff/chanel-min.jpg"),
  },
  {
    name: "Daniel Lee",
    position: "Design",
    description:
      "Hello! My name’s Daniel, and I’m a junior studying Sociology. I enjoy exercising and watching TV shows during my free time! I joined Spero because it allows me to spread the Gospel through designing and interacting with others.",
    image: require("../../images/updated-staff/Daniel-min.jpeg"),
  },
  {
    name: "Daniel Lee",
    position: "Marketing",
    description:
      "Hi y’all! My name is Daniel and I am a second year studying Cognitive Science at UC Berkeley. In my free time, I love playing spikeball and going on spontaneous trips around the Bay! I joined Spero because I get to meet and love new people while being able to share in my conviction of the Gospel!",
    image: require("../../images/updated-staff/daniel-min.jpg"),
  },
  {
    name: "David Lee",
    position: "Operations",
    description:
      "Hi, I'm David! I'm a second year studying Electrical Engineering and Computer Science. I enjoy sports, music, long drives, and just hanging out with friends. I hope that through Spero, God would open doors to start conversations and make Himself known to those we interact with!",
    image: require("../../images/updated-staff/david-min.jpg"),
  },
  {
    name: "Minoo Kim",
    position: "Web Developer",
    description:
      "Hello! I'm Minoo, a first year at UC Berkeley studying Data Science. I love playing sports like basketball and judo, hanging for long hours with friends, and watching Youtube. I joined Spero in order to share the Gospel through my passions!",
    image: require("../../images/updated-staff/minoo-min.jpg"),
  },
  {
    name: "Franny Shih",
    position: "Marketing",
    description:
      "Hello!! I'm Franny, a first year majoring in Environmental Economics and Policy. During my free time, I love to hike, play guitar, and try out different restaurants. I love Spero because I get to work with all these amazing people and share the gospel with the community through art.",
    image: require("../../images/updated-staff/franny-min.jpg"),
  },
];
